import React from 'react';
import PropTypes from 'prop-types';
import { FormField } from 'web-ui-components/lib/molecules/forms';
import { Button } from 'web-ui-components/lib/atoms/buttons';

const RemovableField = ({
  id,
  inputProps,
  label,
  validationMessage,
  hasError,
  onRemoveField,
  suffix
}) => {
  return (
    <div
      className="c-m-search-and-select__item c-m-search-and-select__item--is-visible"
      data-search-select-item={label}
    >
      <div className="c-m-search-and-select__item-header">
        <label className="c-m-search-and-select__item-title">{label}</label>
        <Button
          width="flush"
          type="button"
          className="c-m-search-and-select__item-action u-margin-padding-0"
          onClick={() => {
            onRemoveField(id);
          }}
        >
          Remove
        </Button>
      </div>
      <div className="c-m-search-and-select__item-field">
        <FormField
          validationMessage={validationMessage}
          hasError={hasError}
          type="number"
          suffix={suffix}
          inputProps={inputProps}
        />
      </div>
    </div>
  );
};

RemovableField.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  validationMessage: PropTypes.string,
  hasError: PropTypes.bool,
  onRemoveField: PropTypes.func,
  onChange: PropTypes.func
};
RemovableField.defaultProps = {
  hasError: false
};
export default RemovableField;
